/**
 * (c) 津职模拟考
 */

let url = "https://api.jzkszx.com";
export default {
  url: url,
};
